var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { LinearProgress, Button } from '@material-ui/core';
import styled from 'styled-components';
import QuestionViewerStatus from '../QuestionViewerStatus';
const ProgressButtonWrapper = styled.div `
    position: relative;
`;
const ButtonProgress = styled(LinearProgress) `
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
`;
const CountdownOverlay = styled.div `
    position: absolute;
    padding-top: 0.6rem;
    top: 0;
    color: ${(props) => props.theme.colors.white};
    width: 100%;
    height: 100%;
    border-radius: 4px;
    text-align: center;
`;
const QuestionViewerSubmitButton = React.forwardRef(function QuestionViewerSubmitButtonRefForwarder(_a, ref) {
    var { status: statusFromProps, timeoutProgress, timeoutInSeconds } = _a, otherProps = __rest(_a, ["status", "timeoutProgress", "timeoutInSeconds"]);
    const status = statusFromProps !== null && statusFromProps !== void 0 ? statusFromProps : QuestionViewerStatus.Initial;
    const renderButtonProgress = () => {
        if (status === QuestionViewerStatus.Submitting && timeoutProgress && timeoutInSeconds) {
            return (React.createElement(React.Fragment, null,
                React.createElement(ButtonProgress, { variant: "determinate", value: (timeoutProgress / timeoutInSeconds) * 100 }),
                React.createElement(CountdownOverlay, null, `${timeoutInSeconds - timeoutProgress}s`)));
        }
        return null;
    };
    return (React.createElement(ProgressButtonWrapper, null,
        React.createElement(Button, Object.assign({ ref: ref, "data-testid": "questionView-submit", color: "primary", variant: "contained" }, otherProps), "Submit"),
        renderButtonProgress()));
});
export default QuestionViewerSubmitButton;
//# sourceMappingURL=index.js.map